import React from "react";
import "./NewsCard.css";

const NewsCard4 = () => {
  const handleSourceClick = () => {
    window.open("https://www.myjoyonline.com/government-colloaborates-with-insurance-pension-regulators-to-develop-annuity-syndiacte-markets/", "_blank");
  };

  return (
    <div>
    <section className="section-council">
    <div className="sectiontop-line"></div>
    <h2 className="sectiontitle">LATEST NEWS</h2>
    <div className="sectionbottom-line"></div>
    </section>
    <h2 className="newstoptitle">
    Government collaborates with insurance, pension regulators to develop annuity, syndicate markets
    </h2>
    <div className="newscard">
    
      <img
        src="images\News\news4.jpeg" 
        alt="News"
        className="newsimage"
      />

     
      <h3 className="newstitle">
      Government collaborates with insurance and pension regulators
      </h3>

     
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
          www.myjoyonline.com
          </button>
        </span>
        <span className="newsdate">14 June 2022</span>
      </div>

      
      <p className="newsdescription">
            Government is strongly collaborating with regulators in the insurance and pensions 
            industry to develop annuity and syndicate markets.
            <br />
            <br />
            According to the Head of Pensions and Insurance Unit at the Ministry of Finance, 
            Benjamin Torsah-Klu, this will stimulate long term investments of pension and insurance funds.
            <br />
            <br />
            Speaking on behalf of the Finance Minister, Ken Ofori-Atta at the 6th African Actuarial Congress 
            ongoing in Accra, he said government is committed to the 
            creation of long term funding for economic development.
            <br />
            <br />
            “Government is strong collaborating with the regulators in the insurance and pension industry 
            to develop an annuity and a syndicate market. This market will encourage long term investments and 
            pension funds, whereas the market will also encourage insurance risk businesses among the oil and gas sector”.
            <br />
            <br />
            Chief Actuary at the Social Security and National Insurance Trust, Joseph Poku, for his part said the 
            Trust is focused on expanding and deepening coverage of the basic national socials security scheme.
            <br />
            <br />
            He added that the recent actuary valuation suggest the need to review the 
            funding rate of the scheme to guarantee payment of the pension in the long term.
            <br />
            <br />
            Speaking to Joy Business, Neil Tagoe, President of Actuarial Society of Ghana said Ghanaian 
            actuaries should adopt insurance technology to grow the pensions and insurance industry.
            <br />
            <br />
            He mentioned that Actuaries and the Actuarial Society of Ghana (ASG) in particular 
            strongly supports the National Insurance Commission (NIC) efforts in strengthening the 
            local insurance industry by transitioning to a Risk-Based Capitalisation regime.
            <br />
            <br />
            “While we agree with the various regulators too - the NIC, the NPRA, BOG and SEC that the 
            consolidated impact of these efforts and major changes is to ensure a sound and financially 
            stable economy but a more critical growing concern is the utilisation of the actuary to guide these 
            regulatory transitions process since the technical skill to drive any form capitalization 
            predominantly rest with us the Actuaries”, he added.
            <br />
            <br />
            The theme for the congress was the “the Risk Based Capital Regime and Data Driven Economy”.
      </p>
    </div>
    </div>
  );
};

export default NewsCard4;
